module.exports = __webpack_public_path__ + "assets/ic-telegram.3433e30c.svg";